import PropTypes from 'prop-types';
import React, { useEffect, useMemo } from 'react';
import {
  availableLanguages,
  COMPONENTS,
} from '../../components/common/webSiteLanguages';
import GlobalDataContext from './globalDataProvider.context';

export const LOCAL_COUNTRY = 'ly_country';
export const LOCAL_LANGUAGE = 'ly_language';

const windowGlobal = typeof window !== 'undefined' && window;

export const setLocalLanguage = ({ country, language }) => {
  localStorage.setItem(LOCAL_COUNTRY, country);
  localStorage.setItem(LOCAL_LANGUAGE, language);
};

export const getLocalLanguage = () => ({
  country: localStorage.getItem(LOCAL_COUNTRY),
  language: localStorage.getItem(LOCAL_LANGUAGE),
});

let storageCountry;
let storageLanguage;

if (windowGlobal) {
  storageCountry = localStorage.getItem(LOCAL_COUNTRY);
  storageLanguage = localStorage.getItem(LOCAL_LANGUAGE);
}

export const DEFAULT_COUNTRY = storageCountry || 'us';
export const DEFAULT_LANGUAGE = storageLanguage || 'en';
const DEFAULT_ACTIVECOMPONENT = COMPONENTS.HOME;

export const getLocByUrls = ({ pathname }) => {
  if (!windowGlobal && !pathname) return false;
  const urlToUse = pathname || window.location.pathname;
  const parts = urlToUse.split('/').filter((el) => el !== null && el !== '');
  const availableLanguage = availableLanguages.find(
    (c) => c.country === parts[0],
  );
  const locationCountry = parts.length > 0 && availableLanguage ? parts[0] : false;
  let locationLanguage = false;
  if (parts.length > 0 && locationCountry) {
    locationLanguage = availableLanguage.languages.find(
      (value) => value === parts[1],
    );
  }
  const values = locationCountry && locationLanguage
    ? { country: locationCountry, language: locationLanguage }
    : { country: DEFAULT_COUNTRY, language: DEFAULT_LANGUAGE };
  return values;
};

const GlobalDataProvider = function ({
  children,
  location,
  pageContext: {
    country, language, slug, activeComponent,
  },
}) {
  const nLocation = {
    pathname: '',
    search: '',
  };
  const { pathname } = location || nLocation;
  const showLanguageSelector = (!country || !language) && !storageCountry && !storageLanguage;
  const nCountry = country || (getLocByUrls({ pathname }) || {}).country;
  const nLanguage = language || (getLocByUrls({ pathname }) || {}).language;
  const nActiveComponent = activeComponent || DEFAULT_ACTIVECOMPONENT;

  useEffect(() => {
    setLocalLanguage({
      country: country || storageCountry || DEFAULT_COUNTRY,
      language: language || storageLanguage || DEFAULT_LANGUAGE,
    });
  }, [country, language]);

  const currentCountryConfigs = useMemo(
    () => availableLanguages.find((c) => c.country === nCountry),
    [nCountry],
  );

  const value = useMemo(
    () => ({
      path: pathname,
      country: nCountry,
      language: nLanguage,
      currentCountryConfigs,
      slug,
      activeComponent: nActiveComponent,
      showLanguageSelector,
    }),
    [
      pathname,
      nCountry,
      nLanguage,
      currentCountryConfigs,
      slug,
      nActiveComponent,
      showLanguageSelector,
    ],
  );
  return (
    <GlobalDataContext.Provider value={value}>
      {children}
    </GlobalDataContext.Provider>
  );
};

GlobalDataProvider.propTypes = {
  children: PropTypes.node.isRequired,
  country: PropTypes.string,
  language: PropTypes.string,
  location: PropTypes.shape({}),
  pageContext: PropTypes.shape({}),
};

GlobalDataProvider.defaultProps = {
  country: undefined,
  language: undefined,
  pageContext: {},
  location: {
    pathname: '/',
  },
};

export default GlobalDataProvider;
